import { NgModule } from '@angular/core';
import {
  BookOpen,
  ChevronDown,
  ChevronRight,
  Circle,
  CircleCheck,
  ClipboardCheck,
  Clock,
  Building2,
  FileStack,
  FileText,
  Flag,
  Folder,
  FolderTree,
  Layers,
  LayoutDashboard,
  LayoutGrid,
  LucideAngularModule,
  Menu,
  Map,
  MapPin,
  Plus,
  Ruler,
  ScanLine,
  ScrollText,
  Search,
  Settings,
  TriangleAlert,
  Upload,
  X,
} from 'lucide-angular';

const lucide = LucideAngularModule.pick({
  LayoutDashboard,
  Flag,
  BookOpen,
  MapPin,
  Map,
  FileText,
  ScanLine,
  Ruler,
  ScrollText,
  ClipboardCheck,
  CircleCheck,
  Clock,
  TriangleAlert,
  Circle,
  Settings,
  ChevronDown,
  ChevronRight,
  Search,
  Layers,
  FolderTree,
  Upload,
  FileStack,
  Plus,
  Building2,
  LayoutGrid,
  Menu,
  Folder,
  X,
});

@NgModule({
  imports: [lucide],
  exports: [LucideAngularModule],
})
export class WorkspaceIconsModule {}
